import axios from 'axios'

export default {
	api: function () {
		return axios.create({
			baseURL: '/questions/api/v1/questions'
		});
	},

	answersApi: function (answerId) {
		return axios.create({
			params: { format: 'json' },
			baseURL: "/answers" + (answerId ? '/' + answerId : '')
		});
	},

	accept: function (answerId) {
		return this.answersApi(answerId).post('/accept');
	},

	unaccept: function (answerId) {
		return this.answersApi(answerId).delete('/accept');
	},

	vote: function (votableId, voteType) {
		let path = votableId + "/votes/" + voteType;

		return this.answersApi().post(path);
	},

	questionPayload: function (question, recaptchaResponse) {
		let data = new FormData();
		if (question.id) {
			data.append('_method', 'put');
		}

		data.append('question[content_category_id]', question.content_category_id);
		data.append('question[system_id]', question.system_id);
		data.append('question[content]', question.content);
		data.append('question[title]', question.title);
		data.append('question[group_id]', Grabcad.currentGroup);
		data.append('g-recaptcha-response', recaptchaResponse);

		question.files.files.forEach(function(file, fileKey) {
			let fileElement = document.getElementById('file-upload-' + fileKey);
			if (fileElement && fileElement.files.length) {
				let newFile = fileElement.files[0];
				data.append('question[attachments][]', newFile);
			}
		});

		question.files.deleted.forEach(function(file) {
			data.append('question[deletable_attachments][]', file.id);
		});

		question.tags.forEach(function(tag) {
			data.append('question[tag_list][]', tag);
		});

		return data;
	},

	answerPayload: function (answer) {
		let data = new FormData();
		if (answer.id) {
			data.append('_method', 'put');
		}

		answer.files.files.forEach(function(file, fileKey) {
			let fileElement = document.getElementById('file-upload-' + fileKey);
			if (fileElement && fileElement.files.length) {
				let newFile = fileElement.files[0];
				data.append('answer[attachments][]', newFile);
			}
		});

		answer.files.deleted.forEach(function(file) {
			data.append('answer[deletable_attachments][]', file.id);
		});

		data.append('answer[content]', answer.content);
		data.append('json', 1);

		return data;
	},

	fetchFilters: function () {
		return this.api().get('/filters').then(function (response) { return response.data; });
	},

	fetchQuestion: function (id) {
		return this.api().get('/' + id).then(function (response) { return response.data; });
	},

	createQuestion: function (question, recaptchaResponse) {
		let payload = this.questionPayload(question, recaptchaResponse);

		return this.api().post('', payload).then(function (response) { return response.data; });
	},

	updateQuestion: function (question) {
		let payload = this.questionPayload(question);
		return this.api().put('/' + question.id, payload).then(function (response) { return response.data; });
	},

	deleteQuestion: function (question) {
		let id = question.id;
		return this.api().delete('/' + id).then(function (response) { return response.data; });
	},

	fetchAnswer: function (answerId, questionCachedSlug) {
		return axios.get('/questions/' + questionCachedSlug + "/answers/" + answerId).then(function (response) { return response.data; });
	},

	createUpdateAnswer: function (answer, questionCachedSlug) {
		let endpoint = '';
		let payload = this.answerPayload(answer);
		if (answer.id) endpoint = '/' + answer.id;

		return axios.post('/questions/' + questionCachedSlug + "/answers" + endpoint, payload)
			.then(function (response) { return response.data; });
	}
}
